import type { ID } from '@octopus-do/octopus-project-core'
import type React from 'react'

import { useScaleZoom } from '@/hooks'
import { clsJoin } from '@/utils'
import { ThreadItem } from './components'
import { useThreadsList } from './hooks'
import css from './styles.module.css'

interface Props {
  target: ID
  // the threads of a page, as opposed to the free ones on the tab
  anchored?: boolean
}

export const Threads: React.FC<Props> = ({ target, anchored = false }) => {
  const { threads, selected, users } = useThreadsList(target)
  const { scale } = useScaleZoom()

  const open = threads.some((t) => t.uuid === selected)

  return (
    <div
      className={clsJoin(
        css.threads_container,
        anchored && css.anchored,
        open && css.open
      )}
    >
      {threads.map((t) => (
        <ThreadItem
          key={t.uuid}
          active={t.uuid === selected}
          scale={scale}
          users={users}
          thread={t}
        />
      ))}
    </div>
  )
}
